import styled from '@emotion/styled';

import { Link } from 'react-router-dom';
import { t } from '@lingui/macro';
import { Text } from 'components/text/Text';
import { BaseButton } from 'components/button/Button';

type AuthLinkProps = {
  linkTo?: string;
  questionText?: string;
  linkText?: string;
  newTab?: boolean;
  onClick?: () => void;
  light?: boolean;
};

export const AuthLink = ({
  linkTo,
  questionText = t`Not already a user?`,
  linkText = t`Sign up here`,
  newTab = false,
  onClick,
  light = false,
}: AuthLinkProps) => {
  const color = light ? 'tertiary' : 'secondary';
  return (
    <AuthLinkContainer>
      <Text variant="bodyXs" color={color}>
        {questionText}
      </Text>
      {linkTo ? (
        <Link to={linkTo} target={newTab ? '_blank' : undefined} onClick={onClick}>
          <Text variant="bodyXs" weight="semiBold" underlined color={color}>
            {linkText}
          </Text>
        </Link>
      ) : null}
      {onClick && !linkTo ? (
        <BaseButton onClick={onClick} type="button">
          <Text variant="bodyXs" weight="semiBold" underlined color={color}>
            {linkText}
          </Text>
        </BaseButton>
      ) : null}
    </AuthLinkContainer>
  );
};

const AuthLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;
